import '@ant-design/compatible/assets/index.css';
import { CloseOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import React from 'react';
import modal from '~components/modal';
import PartnerRegisterCityEditor from './editor';

@modal(
  {
    className: 'partner-register-city-editor-modal',
  },
  true,
)
class PartnerRegisterCityEditorContainer extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { t, editParams } = this.props;

    return (
      <div className="partner-register-city-editor">
        <div className="partner-register-city-editor__header">
          {t(`cms.referral.partner.detail.editor.register_city.title`)}
          <CloseOutlined
            className="partner-register-city-editor__close-button"
            onClick={this.props.handleCloseModal}
          />
        </div>
        <PartnerRegisterCityEditor
          partnerId={editParams.partnerId}
          currentCityId={editParams.currentCityId}
          partnerCountrySlug={editParams.partnerCountrySlug}
          onClose={this.props.handleCloseModal}
        />
      </div>
    );
  }
}

PartnerRegisterCityEditorContainer.propTypes = {
  t: PropTypes.func.isRequired,
  editParams: PropTypes.object.isRequired,
  handleCloseModal: PropTypes.func.isRequired,
};

PartnerRegisterCityEditorContainer.defaultProps = {
  t: () => {},
  editParams: {},
  handleCloseModal: () => {},
};

export default PartnerRegisterCityEditorContainer;
